





















import { Component, Prop, Vue } from 'vue-property-decorator';
import Label from '@/components/Label2.vue';
import ArrowDown from '@/components/ArrowDown.vue';
import Selected from '@/components/Selected.vue';
import { mapState } from 'vuex';
import Enjoy from '@/components/Enjoy.vue';
import EnjoySafety from '@/components/EnjoySafety.vue';
import VehicleSafety from '@/components/VehicleSafety.vue';

@Component({
  components: {
    Label,
    ArrowDown,
    Selected,
    Enjoy,
    EnjoySafety,
    VehicleSafety,
  },
  computed: mapState(['isMobole', 'currentPage', 'seriesType']),
})
export default class series extends Vue {
  seriesType!: String;
  currentPage!: String;

  mounted() {}
}
